export const WORKSPACE_DOMAINS_KEY_BASE = 'workspace_domains';
export const WorkspaceDomainsKeyFactory = {
    all: () => [WORKSPACE_DOMAINS_KEY_BASE],
    byWorkspace: (workspaceId) => [
        ...WorkspaceDomainsKeyFactory.all(),
        workspaceId,
    ],
};
